import styled from 'styled-components';

const Root = styled.div`
  max-width: 810px;
`;

const QuoteIcon = styled.div`
  font-size: 70px;
  font-style: italic;
  line-height: 0;
  padding-top: 20px;
  margin-left: -4px;
  font-weight: 800;
`;

const Footer = styled.footer`
  font-weight: 900;
  font-size: 14px;
  text-transform: uppercase;
  color: #9b9b9b;
`;

const Text = styled.p`
  font-size: 24px;
`;

const Quote = ({ byline, quote }) => (
  <Root>
    <blockquote>
      <QuoteIcon>&quot;</QuoteIcon>
      <Text>{quote}</Text>
      {byline && <Footer>- {byline}</Footer>}
    </blockquote>
  </Root>
);

export default Quote;
